<template>
  <el-form :rules="rules" :model="form" ref="ruleFormRef">
    <el-form-item prop="text">
      <el-input
        autosize
        type="textarea"
        v-model="form.text"
        placeholder="Enter your comment"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="submitForm('ruleFormRef')">
        Send
      </el-button>
    </el-form-item>
  </el-form>
</template>


<script>
import ApiTask from "@/api/task";
export default {
  props: {
    taskId: {
      default: 0,
      type: Number,
    },
  },
  data() {
    return {
      loading: false,
      form: {
        text: "",
      },
      rules: {
        text: [
          { required: true, message: "Please input text", trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    isCreateModal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.form.taskId = this.taskId;
          ApiTask.comment(this.form).then((responce) => {
            if (!responce.status) {
              this.$notify({
                title: "Error",
                message: "Something wrong",
                type: "error",
              });
            } else {
              this.$notify({
                title: "Success",
                message: "Comment saved",
                type: "success",
              });
              this.$emit("createdComment", this.form);
              this.$refs[formName].resetFields();
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
  mounted() {},
};
</script>
